"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FLOORS = exports.UNIT_TYPES = exports.METER_STATUSES = exports.METER_TYPES = exports.MAX_UNITS = exports.UNITS_STATUSES = exports.BILLED_DIRECTLY_BY_ESKOM = exports.VOLTAGE_LEVELS = exports.BUILDING_TYPES = exports.TRANSMISSION_ZONES = exports.BUILDING_STATUS = exports.INITIAL_SORT_DESCRIPTOR = exports.LOCALITY = exports.INITIAL_VISIBLE_UNITS_COLUMNS = exports.INITIAL_VISIBLE_COLUMNS = void 0;
exports.INITIAL_VISIBLE_COLUMNS = ["name", "address.full_address", "building_number", "city", "province", "country", "status", "actions"];
exports.INITIAL_VISIBLE_UNITS_COLUMNS = ["unit_number", "building_id", "building_number", "active", "status", "actions"];
exports.LOCALITY = [
    { label: "Urban", value: "URBAN" },
    { label: "Rural", value: "RURAL" },
    { label: "Peri-Urban", value: "PERI_URBAN" },
];
exports.INITIAL_SORT_DESCRIPTOR = {
    column: "created_at",
    direction: "descending",
};
exports.BUILDING_STATUS = [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
    { label: "Draft", value: "DRAFT" },
];
exports.TRANSMISSION_ZONES = [
    { label: "0-300km", value: "0-300km" },
    { label: "301-600km", value: "301-600km" },
    { label: "601-900km", value: "601-900km" },
    { label: ">900km", value: ">900km" },
];
exports.BUILDING_TYPES = [
    { label: "Residential", value: "RESIDENTIAL" },
    { label: "Commercial", value: "COMMERCIAL" },
    { label: "Industrial", value: "INDUSTRIAL" },
    { label: "Institutional", value: "INSTITUTIONAL" },
];
exports.VOLTAGE_LEVELS = [
    { label: "<500V", value: "<500V" },
    { label: ">=500V and <66kV", value: ">=500V and <66kV" },
    { label: ">=66kV and <=132kV", value: ">=66kV and <=132kV" },
    { label: ">132kV", value: ">132kV" },
];
exports.BILLED_DIRECTLY_BY_ESKOM = [
    { id: 1, label: "Yes", value: true },
    { id: 2, label: "No", value: false },
];
exports.UNITS_STATUSES = [
    { label: "Occupied", value: "OCCUPIED" },
    { label: "Vacant", value: "VACANT" },
    { label: "Under Maintenance", value: "UNDER_MAINTENANCE" },
];
exports.MAX_UNITS = 10;
exports.METER_TYPES = [
    { label: "Electrical", value: "ELECTRICAL" },
    { label: "Water", value: "WATER" },
];
exports.METER_STATUSES = [
    { label: "Active", value: "ACTIVE" },
    { label: "Inactive", value: "INACTIVE" },
    { label: "Faulty", value: "FAULTY" },
    { label: "Maintenance", value: "MAINTENANCE" },
];
exports.UNIT_TYPES = [
    { label: "Apartment", value: "APARTMENT" },
    { label: "Flat", value: "FLAT" },
    { label: "Office", value: "OFFICE" },
    { label: "Retail", value: "RETAIL" },
    { label: "Warehouse", value: "WAREHOUSE" },
    { label: "Other", value: "OTHER" },
];
exports.FLOORS = [
    { label: "Basement 3", value: "Basement 3" },
    { label: "Basement 2", value: "Basement 2" },
    { label: "Basement 1", value: "Basement 1" },
    { label: "Ground Floor", value: "Ground Floor" },
    { label: "1st Floor", value: "1st Floor" },
    { label: "2nd Floor", value: "2nd Floor" },
    { label: "3rd Floor", value: "3rd Floor" },
    { label: "4th Floor", value: "4th Floor" },
    { label: "5th Floor", value: "5th Floor" },
];
